module.exports = __webpack_public_path__ + "img/en.5a04da5b.png";